/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-07 10:11:03
 */
export default{
    base:{
        id:'ID',
        search:'Search',
        add:'Add',
        edit:'Edit',
        save:'Save',
        delete:'Delete',
        cancel:'Cancel',
        canceled:'Canceled',
        download:'DownLoad',
        downloading:'Downloading...',
        push:'Push',
        release:'Release',
        use:'Use',
        forbidden:'Forbidden',
        released:'Released',
        invalid:'Invalid',
        test:'Test',
        customCol:'Custom Columns',
        person:'Person Center',
        logout:'Log out',
        login:'Login',
        logoutMsg:'Confirm to exit the current login?',
        tip:'Tip',
        confirm:'Confirm',
        confirm2:'Confirm',
        cancelReplace:'Cancel Replace',
        reset:'Reset',
        yes:'Yes',
        no:'No',
        YES:'YES',
        NO:'NO',
        ok:'OK',
        uploadFirmware:'Upload firmware',
        total:'Total',
        page:'Page',
        row:'Rows',
        upload:'Upload',
        uploadPicture:'Upload Picture',
        enter:'Please Enter',
        select:'Please Select',
        great:'Great',
        homeTitle:"works of art don't have to follow trends, they can lead trends themselves",
        selectFile:'Select File',
        selectDateRange:'Please select a date range',
        noData:'No Data',
        dataView:"DataView",
        downLoad:"DownLoad",
        close:"Close",
        refresh:'Refresh',
        currentDate:'Current Date',
        week:'Week',
        operate:'Operation',
        operateSuccess:'Operate Success',
        operateFail:'Operate Failed',
        getDataFail:'Get Data Failed',
        order_number:'No.',
        customColumns:'Custom Columns',
        delMsg:'Are you sure to delete?',
        uploadImg:'Upload Image',
        needUploadImg:'Please upload pictures!',
        imgTooLarge:'Image must be less than 10MB!',
        pictureUploading:'Picture uploading...',
        uploadSuccess:'Upload success!',
        uploading:'Uploading...',
        addSuccessMsg:'Successfully Added！',
        editSuccessMsg:'Successfully Edited！',
        delSuccessMsg:'Successfully Deleted！',
        saveSuccessMsg:'Successfully Save！',
        createSuccessMsg:'Successfully Created！',
        cancelSuccessMsg:'Canceled successfully！',
        sendSucceeded:'Send successfully !',
        downloadSucceeded:'Download successfully !',
        downloadFailed:'Download failed, please try again!',
        deleteConfirm:'Are you sure want to delete it?',
        clearLocalStorage:'Clear Cache',
        hasEmptyItem:'There are empty data items. Please fill them out before submitting!',
        more:'More',
        pickDate:"Please Select A Date",
        summary:'Summarize All',
        weekSummary:'Weekly Summary',
        normal:'Normal',
        selectConfirmMsg:'Are you sure about the selected item? Clicking OK will save the data',
        noEmpty:'can not be empty！',
        logoText:'Diagnostic Tool Management',
        zh:'CH',
        en:'EN',
        de:'DE',
        fr:'FR',
        exportData:'Export data',
        rows:'Rows',
        emailFormatError:'Please enter the correct email address format !',
        export:'Export',
        exporting:'Exporting...',
        exportSuccess:'Export successfully !',
        km:'KM',
        top: 'Top',
        GOBAO:'GOBAO',
        HEPHA:'HEPHA',
        corest:'Corest',
        birk:'Birk',
        pleaseSelect:'Please Select',
        checkAll:'Check All',
        rollBack:'Version Rollback',
        revokeDelete:'Revoke Delete',
        error:'Error',
        url:'URL',
        method:'Method',
        user:'User',
        rideData:'Riding Data',
        resend:'Resend',
        interfaceName:"Interface Name",
        pleaseSelectRole:'Please select role',
        modify:'Modify',
        success:'Success',
        email:'Email',
        pageNotFound:'Sorry, the page you visited does not exist.',
        backHome:'Back Home',
        allow:'Allow',
        notAllow:'Not allowed',
        previous:'Previous',
        next:'Next',
        detail:'Detail',
        saveSuccess:'Save successfully!',
        all:'All',
        select:'Select',
        version:'version',
        version2:'Version',
        record:'Record',
        status:'Status',
        app:'App',
        serviceTool:'Service Tool',
        backend:'Backend',
        record:'Record',
        failedReason:'failed Reason',
    },
    menu:{
        Home:'Home',
        DataQuery:'Data Query',
        CyclingData:'Riding Data',
        BikeInfo:'Bike Information',
        PartDistribution:'Parts Distribution',
        PartsVersionStatistic:'Parts Version Statistic',
        AdvancedFunction:'Adv. Feature',
        AccessMTG:'Access Management',
        AccountMTG:'Account Management',
        SystemMTG:'System Settings',
        Role:'Role Management',
        Menu:'Menu Management',
        Firmware:'Firmware Management',
        FirmwareRelease:'Firmware Release',
        FirmwareList:'Firmware List',
        FirmwareSetting:'Firmware Setting',
        Fault:'Fault Management',
        FaultDataBoard:'Fault Data Board',
        FaultCodeMaintenance:'Fault Code Maintenance',
        BikeModel:'Bike Model Management',
        Tenant:'Tenant Management',
        RideDataStatistic:'Ride Data Statistic',
        User:'User Management',
        ErgoAdjust:'E-bike Geometric Params',
        PartProjectTenant:'Parts Correspondence',

        subHome:'Welcome to e-bike control center.',
        subCyclingData:'User riding data statistics and management.',
        subBikeInfo:'Configuration information management.',
        subPartDistribution:'',
        subPartsVersionStatistic:'',
        subAccessMTG:'Digitalize authorization management to better serve your users.',
        subAccountMTG:'Administrators can manage permissions for backend accounts.',
        subRoleMTG:'Administrators can manage roles for backend accounts.',
        subMenuMTG:'Administrators can manage menus for backend accounts.',
        subFirmware:'',
        subFirmwareList:'',
        subFirmwareRelease:'',
        subFirmwareSetting:'',
        appVersion:'App Version Management',
        subAppVersion:'',
        upgradeRules:'Upgrade Rules',
        subUpgradeRules:'',
        toolPublishManagement:'Service Tool Publish',
        subToolPublishManagement:'',
        subFaultData:'',
        subTenant:'',
        subUser:'',
        subRideDataStatistic:'',
        subErgoAdjust:'',
    },
    tool:{
        fileName:'File name',
        fileNo:'File no.',
        filePath:'File path',
        fileSize:'File size',
        downloadPath:'Download path',
        fileCategory:'Category',
        status:'Status',
        latestPath:'Latest path',
        activated:'Activated',
        unactivated:'Unactivated',
        upload:'Upload',
        uploadCategory:'Upload category',
        category:'Category',
        selectFiles:'Select files',
        app:'App',
        service:'Service tool',
        filesCannotBeEmpty:'Files can not be empty',
        createTime:'Create time',
        file:'File',
        versionUpdateContent:'Version update content',
        descriptionEn:'Description(En)',
        descriptionDe:'Description(De)',
        descriptionFr:'Description(Fr)',
        descriptionNl:'Description(Nl)',
    },
    login:{
        loginSucceeded:'Login succeeded !',
        resetSucceeded:'Reset succeeded! Please log in again.',
        desc:'Before accessing the e-bike control center.',
        subDesc:'Please log in to your account.',
        email_address:'Email address',
        password:'Password',
        login:'Log in now',
        rememberPassword:'Remember me',
        send:'Send',
        reset:'Reset',
        forgotPassword:'Forgot the password?',
        createAccount:'Create an account',
        createSubDesc:'Please fill in your contact information.',
        resetPassword:'Reset password',
        resetSubDesc:'Please fill in the email address you used at registration to reset your password.',
        adminEmail:"Administrator's email",
        firstName:'First name',
        lastName:'Last name',
        companyName:'Company name',
        emailAddress:'Email address',
        telephone:'Telephone',
        comfirmPassword:'Comfirm password',
        verificationCode:'Verification code',
        newPassword:'New password',
        reEnterPassword:'Re-enter the password',
        createAccountBtn:'Sent request to create an account',
        requestOnce:'You can only request a verification code once per minute.',
        hephaAdminEmail:"HEPHA administrator's email:",
        useAccountLogin:'Log in using your access credentials',
        note:'Note:',
        msg1:'We will send a confirmation email to you first. Once you confirm the email, your registration information will be recorded in the backend.',
        msg2:'After the administrator activates it in the backend, your account will be successfully registered.',
        msg3:'You are required to confirm the email first, and then the administrator needs to activate your account in the backend.',
        // passwordFormat:'The password support only 6 to 10 numbers and letters, do not support special characters.',
        passwordFormat:'The password must be at least 8 characters long and include uppercase and lowercase letters, and at least one number.',
        confirmPasswordFormat:'Please confirm the password again',

        selectTenant:'Select Tenant',
        selectTenantTip:'Please select tenant account authorization login',
        normal:'Normal',
        noAvive:'No Avive',
        logout:'Log out',
        logoutTip:'Are you sure log out?',

        resend:'Resend email',
        noActiveTip:'Your account is not activated, please check your email for activation instructions or resend the email to activate.',

        readAgreed:'I have read and agreed to the ',
        privacy:'privacy policy',
        and:'and',
        serviceTerm:'terms of service',

        timeout:'Request timeout',
        completeVeriftyTitle:'Please complete security verification',

        verificationSuccessful:'Verification successful',
        verificationFailed:'Verification failed',
        swipeRight:'Swipe right to complete verification',

        passwordResetSuccessful:'Password reset successful.',
        pleaseTryLoginAgain:'Please log in again.',
        noPermissionLogin:'The account does not have permission to log in!',

    },
    home:{
        morning:'Good Morning!',
        forenoon:'Good Forenoon!',
        noon:'Good Noon!',
        afternoon:'Good Afternoon!',
        evening:'Good Evening!',
        welcome:'Welcome to HEPHA Ecological Platform!',

        totalSale:"Total E-Bikes",
        lastWeekActivationNum:"Last week's active users.",
        lastWeekSegmentCount:"Last week's bound users.",
        currentDate:'Local time: ',
        cityDistribution:'Map Of Activated Users',
        table:'Table',
        map:'Map',
        country:'Country',
        state:'State',
        city:'City',
        num:'Number',
        torqueChartTitle:'Statistics of maximum torque.',
        maxTorqueData:'Maximum torque data',
    },
    firmware:{
        order_number:'No.',
        project_no:'Project no.',
        company_id:'Company ID',
        part_no:'Part no.',
        hardware_version:'Hardware version',
        software_version:'Software version',
        creator:'Creator',
        create_time:'Create time',
        file_size:'File size',
        firmwareStatus:'Firmware status',
        environment:'Release environment',
        release_limit:'Release limit',
        operate:'Operate',
        file:'Upload firmware',
        hardware_name:'Hardware name',
        file_name:'File name',
        release_limit_val:'Limit values',
        terminate_time:'Terminate time',
        terminator:'Terminator',
        firmware_desc:'Firmware description(En)',
        firmware_desc_de:'Firmware description(De)',
        firmware_desc_fr:'Firmware description(Fr)',
        firmware_desc_nl:'Firmware description(Nl)',
        firmware_desc_et:'Firmware description(Et)',
        firmware_desc_lv:'Firmware description(Lv)',
        firmware_desc_lt:'Firmware description(Lt)',
        frameNumber:'Frame number',
        assemblyCode:'Assembly code',
        sku:'SKU',

        firmware_description:'Description (En)',
        firmware_description_de:'Description (De)',
        firmware_description_fr:'Description (Fr)',
        firmware_description_nl:'Description (Nl)',
        firmware_description_et:'Description (Et)',
        firmware_description_lv:'Description (Lv)',
        firmware_description_lt:'Description (Lt)',

        uploadFirmware:'Upload firmware',

        not_used:'Not used',
        published:'Published',
        testing:'Testing',
        market_environment:'Market environment',
        production_environment:'Production environment',
        testing_environment:'Testing environment',
        unlimited:'Unlimited',
        base:'Base',
        grayscale:'Grayscale',
        personal:'Personal',

        deleteMsg:'Are you sure forbidden this data?',
        uploadMsg:'Firmware uploaded successfully!',
        forbiddenMsg:'Firmware disabled!',
        releaseMsg:'Please select a publishing environment!',
        limitMsg:'Please select a publishing limit!',
        limitValMsg:'Please enter a publishing limit value!',
        fileMsg:'Please select the firmware to upload!',
        cancelTip: 'Are you sure to cancel?',
        delMsg:'Are you sure delete this data?',
        firmwareDescMsg:'Please enter a firmware description(En)!',
        firmwareDescDeMsg:'Please enter a firmware description(De)!',
        firmwareDescFrMsg:'Please enter a firmware description(Fr)!',
        firmwareDescNLMsg:'Please enter a firmware description(Nl)!',
        firmwareDescEtMsg:'Please enter a firmware description(Et)!',
        firmwareDescLvMsg:'Please enter a firmware description(Lv)!',
        firmwareDescLtMsg:'Please enter a firmware description(Lt)!',

        description:'Firmware  description',
        supportFuzzySearch:'Support fuzzy search',
    },
    cycling:{
        queryUserRideData:'Query user riding data',
        statisticsAllUsers:'Statistics of all users',
        mileageRank:'Mileage ranking',
        downloadUserCyclingListData:'Export user cycling data',
        totalCyclingStatistics:'Total ride statistics',
        frameNumber:'Frame number',
        assemblyCode:'Drive unit sn',
        assemblyCode2:'Assembly code',
        totalDistance:'Total ride distance',
        totalTime:'Total ride time',
        totalRides:'Total no. of rides',
        trampling_laps:'Total trampling laps',
        maxDist:'Max distance per single ride',
        maxCadence:'Max cadence per single ride',
        maxSpeed:'Max speed single ride',
        totalMileageRangeStatistics:'Total mileage range statistics',
        totalNumberOfRidesStatistics:'Total number of rides statistics',
        rideDataUser:'Riding data of user',
        eco:'ECO',
        tour:'TOUR',
        turbo:'TURBO',
        motorCode:'Motor code',
        chartTip1:'Statistical data on motor power and total riding time.',
        chartTip2:'Statistical data on total power and total riding time',
        chartTip3:'Statistical data on riding mode and total riding time',
        chartTip4:'Statistical data on cadence and total riding time.',
        chartTip5:'Statistical data on human toque and total riding time.',
        chartTip6:'Statistical data on motor toque and total riding time.',
        chartTip7:'Please enter the frame number or motor code of the data to be queried.',

        downloadRideData:'Export riding data',

        downloadChart1:'Export motor power statistics data',
        downloadChart2:'Export total human power statistics data',
        downloadChart3:'Export total share of riding mode use',
        downloadChart4:'Export cadence statistics data',
        downloadChart5:'Export human torque statistics data',
        downloadChart6:'Export motor output torque statistics data',

        mileageZoneCountData:'Total mileage range statistics data',
        rideCountData:'Total number of rides statistics data',
        downloadAllUserMileageZoneCount:'Export total mileage range statistics data',
        downloadRideCount:'Export total number of rides statistics data',

        motorPowerStatistics:'Motor power statistics',
        totalHumanPowerStatistics:'Total human power statistics',
        totalShareOfRidingModeUse:'Total share of riding mode use',
        cadenceStatistics:'Cadence statistics',
        humanTramplingTorqueStatistics:'Human torque statistics',
        motorOutputTorqueStatistics:'Motor output torque statistics',

        // humanTorqueStatistics:'Human Torque Statistics',
        // treadmillStatistics:'Treadmill statistics',
       

        rank:'Rankink list',
        top10:'Top 10',
        top20:'Top 20',
        top50:'Top 50',
        top100:'Top 100',
        chartTitle:'E-Bike total mileage(km)',
        chartTitle2:'User total mileage(km)',
        downloadMile:'Export e-bike/user total mileage',
        totalMile:'E-Bike and user total mileage data',

        tripleMileage:'Triple Mileage',
        cyclingMileage:'Cycling Mileage',

        RideDataStatistic:'Ride Data Statistic',
    },
    rideDataStatistic:{
        queryRideDataStatistic:'Query ride data statistic',
        downloadRidePoints:'Download Ride Points',
        downLoadFaultData:'Download Fault Data',
        downLoadMsg:'Downloading...',
        dateMsg:'Please select a date!',
        frameNumberMsg:'Please enter a frame number!',

        frameNumber:'Frame number',
        frame_number:'Frame number',
        user_id:'User ID',
        distance:'Distance',
        ride_no:'Ride no.',
        cost_time:'Riding times',
        power_consumption:'Power consumption',
        off_mode:'Off mode',
        eco_mode:'Eco mode',
        tour_mode:'Tour mode',
        turbo_mode:'Turbo mode',
        man_power:'Man power',
        motor_power:'Motor power',

        ride_points_data:'Ride points data',
        fault_data:'Fault data',
        simplifyData:'Simplify data',
        realtimeData:'Realtime data',
    },
    bikeModel:{
        id:'ID',
        vehicleModelAbbr:'E-Bike short name',
        vehicleModel:'E-Bike model',
        pictureUrl:'E-Bike picture',
        status:'Status',
        vehicleModelId:'E-Bike model ID',
        creatorId:'Creator ID',
        createTime:'Create time',
        cancellerId:'Canceller ID',
        cancelTime:'Cancel time',
        addBikeModel:'Create e-bike model',
        cancelConfirm:'Are you sure to cancel this model?',
        cancelMsg:'Cancal successed!',
        imageUploadTip:'Support .jpg, .jpeg, .png, .webp, max size is 10MB.',
    },
    bikeInfo:{
        queryBikesInfo:'Query bikes info',
        generalInfo:'General information',
        sku:'Sku',
        brand:'Brand',
        bikeColor:'Bike color',
        driveUnitModel:'Drive unit model',
        modelYear:'Model year',
        bikeModel:'Bike model',
        placeOfProduction:'Place of production',
        bikeOfflineTime:'Bike offline time',
        driveUnitSerialNumber:'Drive unit serial number',
        batterySerialNumber:'Battery serial number',
        displaySerialNumber:'Display serial number',
        batteryKeySerialNumber:'Battery key serial number',
        driveUnitHardwareVersion:'Drive unit hardware version',
        batteryHardwareVersion:'Battery hardware version',
        displayHardwareVersion:'Display hardware version',
        driveUnitSoftwareVersion:'Drive unit software version',
        batterySoftwareVersion:'Battery software version',
        displaySoftwareVersion:'Display software version',

        systemInformation:'System information',
        torque:'Torque',
        assistanceLevel:'Assistance level',
        ridingDynamics:'Riding dynamics',
        restistanceCompensation:'Restistance compensation',
        walkModeSpeed:'Walk mode speed',
        wheelCircumference:'Wheel circumference',
        maxSupportedSpeed:'Max. supported speed',
        maxTorque:'Max. torque',

        item:'ITEM',
        eco:'ECO',
        tour:'TOUR',
        turbo:'TURBO',

        bikeData:'Query bike data',
        bikeInfoData:'Bike information data',

        ebikeInfo:'E-Bike information',
        motorInstallationAngle:'Motor installation angle',
        modelSpeedSensor:'Model of speed sensor',
        amountFrontChainring:'The amount of the front chainring',
        maxTeethChainring:'Max. teeth on the front chainring',
        minTeethChainring:'Min. teeth on the front chainring',
        
        speedsCassette:'The number of speeds on the cassette',
        maxTeethCassette:'Max. teeth on the cassette',
        minTeethCassette:'Min. teeth on the cassette',
        maxGearRatio:'Max. gear ratio',
        minGearRatio:'Min. gear ratio',
        numberTeethSprocket:'The number of teeth on the sprocket',
        externalGear:'External gear',
        internalGear:'Internal gear',

        exportTip:'Frame number or drive unit sn can not be empty !',

        motorQRCode:'Motor QR Code',
        ebikeQRcode:'E-Bike QR Code',
    },
    tenant:{
        tenantInfo:'Tenant info',
        mailInfo:'Tenant mail info',
        partPermission:'Part permission',
        policies:'Policies',

        tenant_name:'Tenant name',
        tenant_code:'Tenant code',
        domain_name:'Domain name',
        fault_font_color:'Fault font color',
        app_id:'App ID',
        vali_user_path:'Validate user path',
        firmware_path:'Firmware path',
        jwt_secret:'JWT secret',
        fault_path:'Fault path',
        del_user_path:'Delete user path',
        fault_background_color:'Fault background color',
        project_no:'Project no.',
        picture_path:'Picture path',
        file_path:'File path',
        avatar_path:'Avatar path',
        logo_icon:'Logo icon',
        small_logo_icon:'Small logo icon',
        activate_mileage_type:'Activate mileage (km)',
        warranty_period:'Warranty period (years)',

        mail_host:'Mail host',
        mail_port:'Mail port',
        mail_debug:'Mail debug',
        mail_username:'Mail user name',
        mail_password:'Mail password',
        mail_head_icon:'Mail head icon',
        mail_starttls:'Mail starttls',
        mail_ssl:'Mail ssl',
        default_encoding:'Default encoding',
        mail_auth:'Mail auth',
        mail_protocol:'Mail protocol',
        mail_footer_icon:'Mail footer icon',

        require_hardware_version:'Require hardware version',
        require_software_version:'Require software version',
        require_company_id:'Require company id',
        require_project_no:'Require project no.',
        check_display_theft_prevention:'Check display theft prevention',
        check_motor_bit:'Check motor bit',
        check_motor_bind_status:'Check motor bind status',
        triple_id_trans_frame_number:'Triple id trans frame number',
        require_new_motor_key:'Require new motor key',

        home_path:'Home path',
        locale_language:'Locale language',
        support_path:'Support path',
        assemble_path:'Assemble path',
        privacy_path:'Privacy path',
        warranty_path:'Warranty path',
        fault_can_footer:'Fault can footer',

        privacy_version:'Privacy version',
        warranty_version:'Warranty version',
        privacy_version_format_error:'Privacy version format error.',
        warranty_version_format_error:'Warranty version format error.',
    },
    user:{
        user_name:'User name',
        email:'E-mail',
        mobile:'Phone number',
        gender:'Gender',
        city:'City',
        street_no:'Street number',
        zip_code:'Zip code',
        first_name:'First name',
        last_name:'Last name',
        status:'Status',
        activated:'Activated',
        unactivated:'Unactivated',
        category:'Category',
        appBuilt:'App account',
        commonUser:'Common user',
        google:'Google',
        apple:'Apple',
        facebook:'Facebook',
        lark:'Lark',
        platform:'Platform',
        app:'APP',
        general:'General',
        tenant_admin:'Tenant admin',
        user_source:'User source',
        create_time:'Create time',
        male:'Male',
        female:'Female',
        app:'App',
        backend:'App backend',
        serviceTool:'Service tool',
        sign_type:'Sign type',
        log_in:'Log in',
        log_out:'Log out',
        registration:'Registration',
        verification_code:'Verification code',
        delete_user:'Delete user',
        create_backend:'Create user',
        sign_time:'Sign time',
        country:'Country',
        subdivisions:'Subdivisions',
        city:'City',
        time_zone:'Time zone',
        ip_address:'Ip address',
        trigger_timestamp:'Trigger time',
        latitude:'Latitude',

        versionRecord:'Version/Record',
        privacy_policy_version:'Privacy policy version',
        login_record:'Login record',
        privacy_version:'Privacy version',
        warranty_version:'Warranty version',
        platform:'Platform',
        create_timestamp:'Create time',
        update_timestamp:'Update time',
        sys_org:'Tenant',
        protocol_type:'Protocol type',
        locale_language:'Language',
        privacy_policy:'Privacy policy',
        warranty:'Warranty',
    },
    partDistribution:{
        tenant:'Tenant',
        frameNumber:'Frame number',
        partNumber:'Part no.',
        softwareVersion:'Software version',
        hardwareVersion:'Hardware version',
        downloadData:'Download parts version data',
        partName:'Part name',
        tripleId:'Drive unit sn',
    },
    access:{
        searchUser:'Search User',
        frameNumber:'Frame number',
        motorSN:'Drive unit sn',
        userEmail:'User email',
        phoneKey:'Phone key',
        maximumTorque:'Maximun torque',
        motorChangeStatus:'Motor replacement status',
        upgradeTorqueStatus:'Upgrade torque status',
        editAuth:'Edit',
        changeRecord:'Records/Settings',
        torqueUpgrade:'Torque upgrade',
        unbindUser:'Unbind user',
        paramConfig:'Parameters configuration',
        wheelCircumference:'Wheel circumference',
        maxSpeed:'Max. speed',
        cancelMaxSpeed:'Cancel max. speed',
        cancelWheelCircumference:'Cancel wheel circumference',
        softwareUpdate:'Software update',
        motorReplace:'Motor replacement',
        appBind:'App binding',
        currentSetting:'Current setting',
        poweronSession:'Power-on sessions',
        waiting:'Waiting',
        toBeReplace:'To be replaced',
        cancel:'Cancel',
        partNumber:'Part number',
        partName:'Part name',
        projectNumber:'Project number',
        companyId:'Company ID',
        assemblyCode:'Drive unit sn',
        assemblyCode2:'Assembly code',
        softwareVersion:'Software version',
        hardwareVersion:'Hardware version',
        latestSoftwareVersion:'Latest software version',
        deletePart:'Delete part',
        editTorque:'Edit Torque',
        torqueEditSuccessMsg:'Torque editing successful, waiting for upgrade！',
        unbindBikeUserConfirmMsg:'Are you sure to unbind the ebike user?',
        cancelWheelCircumferenceConfirmTip:'Are you sure to cancel the wheel circumference change?',
        cancelMaxSpeedConfirmTip:'Are you sure to cancel the max. speed change?',
        
        vehicle_name:'E-Bike name',
        color:'Color',
        vehicle_status:'E-Bike name',
        triple_id:'Drive unit sn',

        addConfig:'Add Configs',
        historyVersion:'View Historical Versions',
        versionDate:'Version Date',
        versionTitle:'Config Info Historical Versions',
        createTimestamp:'Create Timestamp',
        creatorId:'Creator ID',
        configInfoConfirm:'Config Info Confirm',
        replaceConfig:'Update Config',

        init_torque:'Init torque',
        target_torque:'Target torque',
        status:'Status',
        create_time:'Create time',
        cancel_time:'Cancel time',
        finish_time:'Finish time',

        bind_email:'Bind email',
        bind_category:'Bind category',
        bind_time:'Bind time',
        bind_mode_category:'Bind Mode Category',

        confirmMsg:'Are you sure you want to apply for motor replacement?',
        confirmMsg2:'Are you sure to apply for updating the configuration?',
    
        bindRecord:'App Bind',
        torqueUpgradeRecord:'Torque Upgrade',
        motorApplyRecord:'Motor Replace',
        deletePartConfirmMsg:'Are you sure to delete part?',
        cancelTorqueUpgradeMsg:'Are you sure to cancel the torque upgrade?',
        cancelMotorApplyMsg:'Are you sure to cancel the motor replacement application?',

        activated:'Activated',
        unbound:'Unbound',
        maintenance:'Maintenance',
        main_vehicle:'Main e-bike',
        free_vericle:'Free e-bike',
        delivery:'Delivery',
    
        marketVehicle:'Market e-bike',
        testVehicle:'Test e-bike',
        plc:'PLC',
        can:'CAN',
        unboundSuccessful:'Unbind successfully!',
        applyed:'Applied for',
        saveConfigTip:'Please add configs!',

        config_name:'Name',
        config_name_en:'Name(EN)',
        config_name_de:'Name(DE)',
        config_device:'Device',
        config_item:'Config Item',
        config_encrypt:'Encrypt',
        config_max:'Max Value',
        config_min:'Min Value',
        config_size:'Size',
        config_unit:'Unit',
        config_value:'Value',
        config_coefficient:'Coefficient',
        valueMaxTip:'Cannot exceed the maximum value!',
        valueMinTip:'Cannot be less than the minimum value!',
        confirmRollBackTip:'Are you sure to roll back to this version?',
        noVersionData:'No Version Data',
        rollBackSuccess:'Version rollback successful!',
        binding:'Binding',
        unbinding:'Unbinding',
        assembly:'Assembly',
        frame:'Frame',
        waitUpgrade:'Waiting for upgrade',
        finish:'Finish',
    
        applyReplaceMotor:'Replace Motor',

        deleteSuccessful:'Delete Successfully!',
        motorReplacement:'Motor replacement',

        configInfo:'Config Info',
        confirmConfigInfoMsg:'Please confirm the config information!',
    
        cycling_mileage:'Riding mileage',
        cadance:'Cadance',
        tripleId:'Triple ID',
        meter:'Meter',
        init_triple_id:'Init drive unit sn',
        target_triple_id:'Target drive unit sn',
        apply_status:'Replace Status',
        apply_create_time:'Create date',
        replace_category:'Category',

        phone_key:'Phone Key',
        motorKey:'Motor Key',
        assist_level:'Assist level',
        maximum_torque:'Maximum torque',
        mode:'Mode',
        trolley_speed:'Walk mode speed',
        recognition_sensitivity:'Recognition sensitivity',
        start_response:'Start response',

        ride_no:'Ride no.',
        distance:'Distance',
        cost_time:'Riding times',
        average_speed:'Average speed',
        highest_speed:'Highest speed',
        power_consumption:'Power consumption',
        eco_mode:'Eco mode',
        tour_mode:'Tour mode',
        turbo_mode:'Turbo mode',
        off_mode:'Off mode',
        auto_mode:'Auto mode',
        boost_mode:'Boost mode',
        ride_date:'Ride date',
        channel:'Channel',
        serviceTool:'Service Tool',
        app:'App',

        allTenant:'All Tenant',

        valueRange:'The modification range is ± 15% of the current value, and it should be between 1300mm and 3100mm',
        referenceValue:'Reference value',
        replaceMotorTip:'Please confirm whether to grant the motor replacement authorization for this motor.',

        log:'Log',
        errorLog:'Upgrade error attachment log',
        faultLog:'Fault log',
        bluetoothLog:'Bluetooth log',
        poweronLog:'Power-on log',
        upgradeLog:'Update log',
        upgradeTorqueLog:'Upgrade torque log',
        replaceMotorErrorLog:'Replace motor error log',
        log_file:'Log file',

        fault_code:'Fault code',
        fault_parse_plaintext:'Fault name',
        fault_category:'Fault category',
        occur_timestamp:'Fault timestamp',

        poweron_no:'Power-on no.',
        app_version:'App version',
        device_system:'Device system',
        file_no:'File no.',
        assembly_no:'Drive unit sn',
        part_no:'Part no.',
        project_no:'Project no.',
        poweron_time:'Power-on time',
        upgrade_time:'Upgrade time',
        upgrade_excep:'Upgrade excep',
        hardware_version:'Hardware version',
        software_version:'Software version',
        init_software_version:'Init software version',
        start_timestamp:'Start timestamp',
        end_timestamp:'End timestamp',
        start_time:'Start time',
        end_time:'End time',
        replace_time:'Replace time',

        configChangeItem:'Config change items',
        config_old_value:'Old value',
        config_new_value:'New value',
        category:'Category',

        summary:'Summary',
        ebikeBarcode:'E-Bike bar code',
        motorQRCode:'Motor QR code',
        ebikeSetting:'E-Bike setting',
        ebikeRepair:'E-Bike repair',
        ebikeAuth:'E-Bike auth',
        poweronPosition:'Power-on position',
        editCategory:'Edit category',
        getMotorKey:'Motor key',

        userID:'User ID',
        appVersion:'App version',
        rideNo:'Ride no.',
        longitude:'Longitude',
        latitude:'Latitude',
        elevation:'Elevation',
        reportCategory:'Report category',
        reportDate:'Report date',
        reportTime:'Report time',
        poweronOpen:'Power on',
        poweronOff:'Power off',

        autoLight:'Auto light',
        beeper:'Beeper',
        language:'Language',
        lowBattery:'Low battery',
        units:'Units',
        assistLevel:'Assist level',
        wheelDiameter:'Wheel diameter',
        trolleySpeed:'Trolley speed',
        recognitionSensitivity:'Recognition sensitivity',
        startResponse:'Start response',
        settingTime:'Setting time',
        turnOn:'Turn on',
        turnOff:'Turn off',

        repairCategory:'Repair category',
        mesSync:'MES sync',
        repairStartTime:'Repair start time',
        repairEndTime:'Repair end time',
        repairStatus:'Repair status',
        repair:'Repair',
        end:'End',
        repairing:'Repairing',
        returnGoods:'Return',
        synchronized:'Synchronized',
        abnormal:'Abnormal',

        startTimestamp:'Start timestamp',
        endTimestamp:'End timestamp',
        authResult:'Auth result',
        authDesc:'Auth desciption',
        secretKey:'Secret key',
        authTime:'Auth times',
        success:'Success',
        failed:'Failed',
        marketEbike:'Market e-bike',
        testEbike:'Test e-bike',
        more:'More',

        deletePartAll:'Delete all parts',
        deleteAllPartConfirm:'Are you sure to delete all parts?',

        reStoreOffline:'Restore offline',
        restoreOfflineConfirm:'This operation will delete the frame number, are you sure to restore offline?',

        exportRawData:'Export raw data',
        motor:'Motor',
        battery:'Battery',
        display:'Display',
        fault:'Fault',
        type:'Type',
        date:'Date',
        motorRawData:'Motor raw data',
        batteryRawData:'Battery raw data',
        displayRawData:'Display raw data',
        faultRawData:'Fault raw data',

        upload_time:'Upload time',
        ride_timestamp:'Ride date',
        user_category:'Login method',
        google:'Google',
        apple:'Apple',
        facebook:'Facebook',
        appSelf:'App account',
        commonUser:'Common user',

        protocol:'Protocol',
        vehicleStatus:'E-Bike status',
        useMarkup:'Use markup',
        userIdentifier:'User identifier',
        activated:'Activated',
        unbound:'Unbound',
        maintenance:'Maintenance',
        main_vehicle:'Main e-bike',
        free_vericle:'Free e-bike',

        bindSKU:'Bind sku',
        editMVP:'Edit mvp',
        ergoAdjustParams:'E-bike geometric params',
        addErgoAdjustParams:'Add e-bike geometric params',
        editErgoAdjustParams:'Edit e-bike geometric params',
        mvp:'MVP',
        sku:'SKU',
        seat_tube_length:'Seat tube length', // 座管长度(毫米)
        seat_tube_angle:'Seat tube angle', // 座管角度(度)
        stem_adjustable:'Stem adjustable',
        stem_pivot_height:'Stem pivot height', // 把立在转向管上的安装高度(mm)
        stem_length_max:'Stem length max', // 把立最大安装长度(mm)
        saddle_to_seattube_max:'Saddle to seattube max', // 鞍座至座管最大距离(毫米)
        inner_leg_length_max:'Inner leg length max', // 内腿长度最大毫米数
        inner_leg_length_min:'Inner leg length min', // 内腿长度最小值(毫米)
        body_height_max:'Body height max', // 身高最大厘米数
        body_height_min:'Body height min', // 最小身高厘米数
        ergo_adjust_factor:'Ergo adjust factor', // 人体工学调整因子
        bike_max_payload:'Bike max payload', // 自行车最大载重(千克)
        bike_weight:'Bike weight', // 自行车重量(千克)
        head_set_cap_height:'Head set cap height', // 碗组上盖高度度(mm)
        head_tube_angle:'Head tube angle', // 头管角度(度)
        reach:'Reach', // 前伸量(mm)
        stack:'Stack', // 堆高(mm)

        sku2:'SKU：',
        seat_tube_length2:'Seat tube length：',
        seat_tube_angle2:'Seat tube angle：',
        stem_adjustable2:'Stem adjustable：',
        stem_pivot_height2:'Stem pivot height：',
        stem_length_max2:'Stem length max：',
        saddle_to_seattube_max2:'Saddle to seattube max：',
        inner_leg_length_max2:'Inner leg length max：',
        inner_leg_length_min2:'Inner leg length min：',
        body_height_max2:'Body height max：',
        body_height_min2:'Body height min：',
        ergo_adjust_factor2:'Ergo adjust factor：',
        bike_max_payload2:'Bike max payload：',
        bike_weight2:'Bike weight：',
        head_set_cap_height2:'Head set cap height：',
        head_tube_angle2:'Head tube angle：',
        reach2:'Reach：',
        stack2:'Stack：',

        create_timestamp:'Create date',
        update_timestamp:'Update date',
        startDate:'Start date',
        endDate:'End date',

        editRecord:'Edit record',
        field_name:'Field name',
        new_value:'New value',
        old_value:'Old value',
        operation_type:'Operation type',

        inner_leg_length_min_error:'Inner leg length min must be less than inner leg length max',
        inner_leg_length_max_error:'Inner leg length max must be greater than inner leg length min',
        body_height_min_error:'Body height min must be less than body height max',
        body_height_max_error:'Body height max must be greater than body height min',

    },
    account:{
        createAddAccount:'Create/Edit account',
        invitationRegistration:'Invitation registration',
        sendInvitationTotal:'Send invitation total',
        adminAccountEmail:'Super administrator email',

        backendAccountEmail:'Adminstrator email',
        registrationDate:'Registration date',
        authorizerEmail:'Authorizer',
        spareMotorReplace:'Spare motor replacement',
        parameterConfig:'Parameter configuration',
        torqueupGrade:'Torque upgrade',
        unbindUser:'Unbind user',
        usageState:'Usage state',

        userAuthorizedFunc:'User Authorized Functions',

        category:"Account Type",
        status:'Status',
        normal:'Normal',
        unactivated:'Unactivated',
        disabled:'Disabled',
        tenant:'Tenant',

        contractManufacturer:'Assembly account',
        ordinaryBackEndAccount:'Standard backend account',

        auth:'Authorisation',
        authDetail:'Detail',
        authorize:'Authorize',
        updateTorque:'Update torque',
        unbindAccount:'Unbind user',
        diasbleAccount:'Disable account',
        activateAccount:'Enable account',
        diasbleActivate:'Disable/Enable',
        endOffLine:'End of line',
        createConfig:'Create config',

        back:'Back',
        emailAddr:'Email address',
        firstName:'First name',
        lastName:'Last name',
        companyName:'Company name',
        telephone:'Telephone',
        accountType:'Account type',
        tenantAdmin:'Set as tenant super administrator',
        password:'Password',
        confirmPsw:'Confirm password',
        create:'Create',
        createTip1:'lf this email has not been registered, we will send a conformation email to the user. Once confirmed by the user, the email will be successfully added to the backend.',
        createTip2:'lf the email has clearly been registered, you can add it directly to the backend.',

        editTip:'The current email account already exists. Only editing operations are allowed. Please confirm to edit?',

        createTip3:'This account has not been activated yet. To access all features, please activate it first.',
        createTip4:'We’ve sent an activation email to the registered email address.',
        createTip5:'Click “Resend” to request a new activation email, or',
        createTip6:'Contact our after-sales team at ',
        createTip7:' for assistance.',
    
        notice:'Notice',
        unbindTip:'Are you confirmed the unbound user ?',
        disableTip:'Are you confirmed the disable account ?',
        activeTip:'Are you confirmed the active account ?',
    
        pswTip:'The passwords are inconsistent !',
        createSuccessTip:'Please check the email for activation instructions.',
        editSuccessTip:'The account type has been changed.',

        resendEmail:'Resend',
        resendTip:'Are you confirmed resend the activation email?',
        resendEmailTip:'Resend activation email',
    },
    appVersion:{
        platform:'Platform',
        currentVersion:'Current version',
        alertFlag:'Alert flag',
        status:'Status',
        add:'Add',
        number:'No.',
        tenant:'Tenant',
        platformPath:'Platform path',
        releaseId:'Release ID',
        createTime:'Create time',
        operate:'Operate',
        android:'Android',
        ios:'iOS',
        yes:'Yes',
        no:'No',
        normal:'Normal',
        canceled:'Canceled',
        edit:'Edit',
        copy:'Copy',
        cancelTitle:'Tip',
        confirmCancel:'Are you sure you want to cancel this item?',
        cancelFailed:'Cancel Failed',
        tenantRequired:'Tenant cannot be empty',
        platformRequired:'Platform cannot be empty',
        platformPathRequired:'Platform Path cannot be empty',
        versionRequired:'Version cannot be empty',
        alertFlagRequired:'Please Select Alert Flag',
    },
    upgradeRules:{
        add:'Add',
        ruleName:'Rule name',
        priority:'Priority',
        status:'Status',
        createTime:'Create time',
        cancelTime:'Cancel time',
        tenant:'Tenant',
        operate:'Operate',
        addRuleItem:'Add Rule Item',
        partNo:'Part no.',
        ruleHardware:'Rule hardware',
        ruleMinValue:'Rule min value',
        ruleMaxValue:'Rule max value',
        ruleItemPriority:'Rule item priority',
        projectNo:'Project no.',
        canceled:'Canceled',
        normal:'Normal',
        edit:'Edit',
        cancelTitle:'Tip',
        confirmCancel:'Are you sure you want to cancel this item?',
        inputRuleName:'Rule Name cannot be empty.',
        inputPriority:'Priority cannot be empty.',
        inputPartNo:'Part No. cannot be empty.',
        inputRuleHardware:'Rule Hardware cannot be empty.',
        inputRuleMinValue:'Rule Min Value cannot be empty.',
        inputRuleMaxValue:'Rule Max Value cannot be empty.',
        inputRuleItemPriority:'Rule Item Priority cannot be empty.',
        inputProjectNo:'Project No. cannot be empty.',
        minGreaterThanMax:'Min value cannot be greater than max value.',
    },
    partProjectTenant:{
        part_no:'Part no.',
        project_no:'Project no.',
        tenant:'Tenant',
    },
    faultData:{
        tenant:'Tenant',
        sys_org:'Tenant',
        faultDataRate:'Fault data rate',
        faultCodeRate:'Fault code rate',
        faultPartsRate:'Fault Parts Rate',
        normalData:'Normal Data',
        faultData:'Fault Data',
        vehicleFaultRate:'E-Bike fault rate',
        vehicleFaultRateWeek:'E-Bike fault rate',
        faultVehicleNum:'Fault e-bike number',
        reportfaultVehicleNum:'Report fault e-bike number',
        hasRideDataVehicleNum:'Ride data e-bike number',

        faultBms:'Fault Bms',
        faultEcu:'Fault Ecu',
        faultMeter:'Fault Meter',

        sys_org_val:'Tenant',
        protocol:'Protocol',
        fault_path:'URL',
        fault_measure_img:'Imgae',
        fault_status:'Fault Status ',
        fault_limit:'Fault Limit ',
        fault_measure:'Fault Measure ',
        fault_status_de:'Fault Status(German) ',
        fault_limit_de:'Fault Limit(German) ',
        fault_measure_de:'Fault Measure(German) ',
        fault_status_fr:'Fault Status(French) ',
        fault_limit_fr:'Fault Limit(French) ',
        fault_measure_fr:'Fault Measure(French) ',
        fault_status_nl:'Fault Status(Nederlands) ',
        fault_limit_nl:'Fault Limit(Nederlands) ',
        fault_measure_nl:'Fault Measure(Nederlands) ',
        fault_status_et:'Fault Status(Estonian) ',
        fault_limit_et:'Fault Limit(Estonian) ',
        fault_measure_et:'Fault Measure(Estonian) ',
        fault_status_lv:'Fault Status(Latvian) ',
        fault_limit_lv:'Fault Limit(Latvian) ',
        fault_measure_lv:'Fault Measure(Latvian) ',
        fault_status_lt:'Fault Status(Lithuanian) ',
        fault_limit_lt:'Fault Limit(Lithuanian) ',
        fault_measure_lt:'Fault Measure(Lithuanian) ',


        faultDetail:'Fault detail',
        faultDetailTip:'Click on the chart to view the fault details',
        vehicleFaultCodeDistribution:'Distribution of e-bike fault codes',
        faultCodeDistribution:'Detailed distribution of fault codes',

        marketVehicle:'Market e-bike',
        testVehicle:'Test e-bike',
        weekSearch:'Query by week',
        fault10:'Top 10 faults',
        fault15:'Top 15 faults',
        fault20:'Top 20 faults',

        riding:'Riding',
        noRiding:'Not riding',
        frame_number:'Frame number',
        fault_code:'Fault code',
        fault_parse_plaintext:'Fault parse plaintext',
        fault_category:'Fault category',
        ride_no:'Ride no.',
        occur_timestamp:'Occur timestamp',
        summary:'Summarize all',
        totalSale:'Total sales',
        weekSummary:'Week summary',

        link:'Fault Link',
    },
    role:{
        createRole:'Create role',
        edit:'Edit',
        delete:'Delete',
        editRole:'Edit role',
        roleName:'Role name',
        roleDesc:'Role description',
        roleID:'Role ID',
        parentID:'Parent ID',
        tenant:'Tenant',
        roleParent:'Parent role',
        roleIssued:'Create/assign roles permissions',
        directAuth:'Direct authorization',
        inheritFromSuperior:'Inherit from superior',
        gobao:'Gobao',
        hepha:'Hepha',
        deleteTip:'Are you confirmed the deletion of data?',
        bindMenu:'Bind menu',
        bindMenuSuccess:'Bind menu successfully!',
        default:'default',
        admin:'admin',
        test:'test',
        tenantDefault:'Tenant default',
        roleCategory:'Role category',
        systemDefault:'System default',
        selfCreated:'Self-created',
        authTip:'Allow the creation of roles and the allocation of roles to the next lower level',
    },
    menuMgt:{
        createMenu:'Create Menu',
        editMenu:'Edit Menu',
        menuName:'Menu Name',
        menuKey:'Menu Key',
        menuPath:'Menu Path',
        menuIndex:'Menu Index',
        menuParent:'Menu Parent',
        menuLevel:'Menu Level',
        menuType:'Menu Type',
        menuUrl:'Menu URL',
        menuMethod:'Menu Method',
        menuIcon:'Menu Icon',
        menuId:'Menu ID',
        menuCategory:'Menu Category',
        tenantDisplay:'Tenant Display',

        page:'Page',
        button:'Button',
        businessFun:'Business Function',
        interface:'Interface',

        menuTop:'Top-level menu',
        menuLevel1:'First-level',
        menuLevel2:'Second-level',
        menuLevel3:'Third-level',

        serviceTool:'Service Tool',
        backend:'Backend',
        endOffLine:'End-Of-Line (Service Tool)',
        configuration:'Configuration (Service Tool)',
    },
    part:{
        AddPart:'Add Part',
        editPart:'Edit Part',
        model_category:'Model Category',
        model_key:'Assembly Position',
        model_value:'Model Name',
        avatar_url:'Part Picture',
        uploadTitle:'Upload Picture',
        motor:'Drive Unit',
        display:'Display',
        battery:'Battery',

        addFaultCode:'Add Fault Code',
        editFaultCode:'Edit Fault Code',

        fault_code:'Fault Code',
        fault_path:'URL',
        fault_status:'Fault Status',
        fault_limit:'Fault Limit',
        fault_measure:'Fault Measure',
        fault_status_de:'Fault Status (DE)',
        fault_limit_de:'Fault Limit (DE)',
        fault_measure_de:'Fault Measure (DE)',
        fault_status_fr:'Fault Status (FR)',
        fault_limit_fr:'Fault Limit (FR)',
        fault_measure_fr:'Fault Measure (FR)',
    },
    config:{
        label_name:'Label Name(En)',
        label_name_de:'Label Name(De)',
        label_name_fr:'Label Name(Fr)',
        addLabel:'Add Label',
        editLabel:'Edit Label',
    },
    sys:{
        // home:{
        //     home:'Home',
        // },
        // dataQuery:{
        //     cyclingData:'Riding Data',
        //     bikeInfo:'Bike Information',
        // }
    }
}